import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "filert-container" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", {
  class: "filert-container",
  style: {"margin-top":"20px"}
}, null, -1)
const _hoisted_4 = { style: {"overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 修改 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_popover = _resolveComponent("el-popover")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _directive_waves = _resolveDirective("waves")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _withDirectives(_createVNode(_component_el_button, {
        type: "primary",
        class: "filter-item",
        icon: "el-icon-plus",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toAdd()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t("table.add")), 1)
        ]),
        _: 1
      }, 512), [
        [_directive_waves]
      ])
    ]),
    _hoisted_3,
    _withDirectives(_createVNode(_component_el_table, {
      data: _ctx.list,
      key: _ctx.tableKey,
      border: "",
      "highlight-current-row": "",
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, { label: "ID" }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.id), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "功能名称" }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.name), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "终端虚拟币价格" }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.pttAmount), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "管理员虚拟币价格" }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.adminAmount), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "功能",
          width: "500"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_popover, {
              placement: "top-start",
              title: "扩展显示",
              width: 300,
              trigger: "hover"
            }, {
              reference: _withCtx(() => [
                _createVNode("div", _hoisted_4, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(row.functions, (item) => {
                    return (_openBlock(), _createBlock("span", {
                      key: item.id
                    }, [
                      _createVNode(_component_el_button, { size: "small" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  }), 128))
                ])
              ]),
              default: _withCtx(() => [
                _createVNode("div", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(row.functions, (item) => {
                    return (_openBlock(), _createBlock("span", {
                      key: item.id
                    }, [
                      _createVNode(_component_el_button, { size: "small" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  }), 128))
                ])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "功能组类型" }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.type === 0
              ? "普通功能组"
              : row.type === 1
              ? "优惠功能组"
              : "行业功能组"), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "创建时间" }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.time(row.ctime)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "备注" }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.remarks), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "操作",
          label: "操作"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_button, {
              size: "small",
              onClick: ($event: any) => (_ctx.handleEdit(scope.row))
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]), [
      [_directive_loading, _ctx.listLoading]
    ]),
    _withDirectives(_createVNode(_component_el_pagination, {
      total: _ctx.total,
      currentPage: _ctx.listQuery.page.pageNo,
      "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => (_ctx.listQuery.page.pageNo = $event)),
      limit: _ctx.listQuery.page.pageSize,
      "onUpdate:limit": _cache[3] || (_cache[3] = ($event: any) => (_ctx.listQuery.page.pageSize = $event)),
      onSizeChange: _ctx.handleSizeChange,
      onCurrentChange: _ctx.handleCurrentChange,
      "page-sizes": [10, 20, 50, 100],
      layout: "total, sizes, prev, pager, next, jumper"
    }, null, 8, ["total", "currentPage", "limit", "onSizeChange", "onCurrentChange"]), [
      [_vShow, _ctx.total > 0]
    ])
  ]))
}